<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <g>
      <ellipse :style="{'fill': circleFill}" cx="256" cy="256" rx="256" ry="256"/>
    </g>

    <g transform="scale(.6) translate(170 170)">
      <path style="fill:#F28838;" d="M230.772,312.165H219.65h-13.336H195.19h-68.539h-11.122h-13.338H91.068
      c-3.489,0-6.318,2.83-6.318,6.32v85.305c0,3.489,2.828,6.318,6.318,6.318h11.124h13.336h11.122h68.539h11.124h13.336h11.122
      c3.492,0,6.32-2.828,6.32-6.318v-85.305C237.092,314.996,234.263,312.165,230.772,312.165z"/>
      <path style="fill:#4BAF78;" d="M279.002,113.962h11.124h13.336h11.122h68.539h11.124h13.338h11.122c3.492,0,6.32,2.83,6.32,6.32
      v85.305c0,3.489-2.828,6.318-6.32,6.318h-11.122h-13.338h-11.124h-68.539h-11.122h-13.336h-11.124c-3.489,0-6.318-2.828-6.318-6.318
      v-85.305C272.685,116.793,275.513,113.962,279.002,113.962z"/>
      <g>
      <path style="fill:#FFB92E;" d="M425.026,286.207c0-6.172-5.004-11.178-11.178-11.178H248.27c-6.172,0-11.178,5.006-11.178,11.178
      v112.721c0,6.176,5.006,11.178,11.178,11.178h165.579c6.174,0,11.178-5.002,11.178-11.178V286.207H425.026z"/>
      <path style="fill:#FFB92E;" d="M84.75,88.003c0-6.173,5.004-11.178,11.178-11.178h165.576c6.174,0,11.181,5.005,11.181,11.178
      v112.722c0,6.175-5.006,11.178-11.181,11.178H95.929c-6.174,0-11.178-5.003-11.178-11.178V88.003z"/>
      </g>
      <path style="fill:#EF711D;" d="M107.011,403.789v-85.305c0-3.489,2.828-6.32,6.318-6.32h-11.137H91.068
      c-3.489,0-6.318,2.83-6.318,6.32v85.305c0,3.489,2.828,6.318,6.318,6.318h11.124h11.137
      C109.84,410.106,107.011,407.278,107.011,403.789z"/>
      <path style="fill:#299956;" d="M294.945,205.586v-85.305c0-3.489,2.828-6.32,6.318-6.32h-11.137h-11.124
      c-3.489,0-6.318,2.83-6.318,6.32v85.305c0,3.489,2.828,6.318,6.318,6.318h11.124h11.137
      C297.774,211.903,294.945,209.075,294.945,205.586z"/>
      <g>
      <path style="fill:#EF9A1D;" d="M259.352,398.928V286.207c0-6.172,5.006-11.178,11.178-11.178H248.27
      c-6.172,0-11.178,5.006-11.178,11.178v112.721c0,6.176,5.006,11.178,11.178,11.178h22.261
      C264.359,410.106,259.352,405.104,259.352,398.928z"/>
      <path style="fill:#EF9A1D;" d="M107.011,200.725V88.003c0-6.173,5.004-11.178,11.178-11.178H95.929
      c-6.174,0-11.178,5.005-11.178,11.178v112.722c0,6.175,5.004,11.178,11.178,11.178h22.261
      C112.016,211.903,107.011,206.9,107.011,200.725z"/>
      </g>
      <g>
      <path style="fill:#7C7A75;" d="M348.602,383.822h-35.084c-3.69,0-6.678,2.991-6.678,6.678v19.606h48.441V390.5
      C355.28,386.812,352.29,383.822,348.602,383.822z"/>
      <path style="fill:#7C7A75;" d="M306.839,275.029v46.76c0,2.56,1.463,4.894,3.768,6.01c2.304,1.116,5.043,0.816,7.052-0.771
      l13.399-10.593l13.403,10.594c1.202,0.949,2.666,1.439,4.142,1.439c0.991,0,1.985-0.219,2.91-0.668
      c2.304-1.116,3.769-3.452,3.769-6.01v-46.761L306.839,275.029L306.839,275.029z"/>
      <path style="fill:#7C7A75;" d="M154.496,76.826v46.76c0,2.56,1.463,4.894,3.768,6.01c0.925,0.449,1.92,0.668,2.908,0.668
      c1.476,0,2.941-0.489,4.143-1.439l13.403-10.593l13.4,10.592c2.007,1.587,4.746,1.888,7.051,0.771
      c2.304-1.115,3.769-3.45,3.769-6.01V76.826C202.938,76.826,154.496,76.826,154.496,76.826z"/>
      <path style="fill:#7C7A75;" d="M196.258,185.618h-35.084c-3.689,0-6.678,2.99-6.678,6.678v19.607h48.441v-19.607
      C202.937,188.607,199.947,185.618,196.258,185.618z"/>
      <polygon style="fill:#7C7A75;" points="81.165,242.118 30.215,293.068 30.215,242.118 	"/>
      <polygon style="fill:#7C7A75;" points="430.837,242.118 481.784,293.068 481.784,242.118 	"/>
      <polygon style="fill:#7C7A75;" points="81.165,43.915 30.215,94.865 30.215,43.915 	"/>
      <polygon style="fill:#7C7A75;" points="430.837,43.915 481.784,94.865 481.784,43.915 	"/>
      <polygon style="fill:#7C7A75;" points="81.165,440.322 30.215,491.272 30.215,440.322 	"/>
      </g>
      <g>
      <polygon style="fill:#6B6861;" points="53.591,242.118 30.215,242.118 30.215,293.068 53.591,269.693 	"/>
      <polygon style="fill:#6B6861;" points="53.591,43.915 30.215,43.915 30.215,94.865 53.591,71.49 	"/>
      <polygon style="fill:#6B6861;" points="53.591,440.322 30.215,440.322 30.215,491.272 53.591,467.897 	"/>
      </g>
      <polygon style="fill:#7C7A75;" points="430.837,440.322 481.784,491.272 481.784,440.322 "/>
      <path style="fill:#FCA468;" d="M187.561,385.558H139.7c-4.611,0-8.348-3.736-8.348-8.348c0-4.611,3.736-8.348,8.348-8.348h47.861
      c4.61,0,8.348,3.736,8.348,8.348C195.909,381.822,192.17,385.558,187.561,385.558z"/>
      <path style="fill:#61C98D;" d="M370.076,187.355h-47.861c-4.611,0-8.348-3.738-8.348-8.348s3.736-8.348,8.348-8.348h47.861
      c4.61,0,8.348,3.738,8.348,8.348S374.686,187.355,370.076,187.355z"/>
      <g>
      <polygon style="fill:#CCC3A8;" points="89.087,211.903 18.389,211.903 18.389,243.231 89.087,243.231 378.348,243.231
      409.523,243.231 425.634,243.231 496.336,243.231 496.336,211.903 425.634,211.903 	"/>
      <polygon style="fill:#CCC3A8;" points="89.087,410.106 18.389,410.106 18.389,441.435 89.087,441.435 425.634,441.435
      496.336,441.435 496.336,410.106 425.634,410.106 	"/>
      <polygon style="fill:#CCC3A8;" points="425.634,13.7 89.087,13.7 18.389,13.7 18.389,45.028 89.087,45.028 378.348,45.028
      409.523,45.028 425.634,45.028 496.336,45.028 496.336,13.7 	"/>
      </g>
      <g>
      <polygon style="fill:#C9B585;" points="23.595,211.903 18.389,211.903 18.389,243.231 23.595,243.231 44.9,243.231 47.195,243.231
      48.383,243.231 53.59,243.231 53.59,211.903 48.383,211.903 	"/>
      <polygon style="fill:#C9B585;" points="23.595,410.106 18.389,410.106 18.389,441.435 23.595,441.435 48.383,441.435
      53.59,441.435 53.59,410.106 48.383,410.106 	"/>
      <polygon style="fill:#C9B585;" points="48.383,13.7 23.595,13.7 18.389,13.7 18.389,45.028 23.595,45.028 44.9,45.028
      47.195,45.028 48.383,45.028 53.59,45.028 53.59,13.7 	"/>
      </g>
      <g>
      <path style="fill:#36A1CB;" d="M512,90.528V13.951C512,6.245,505.755,0,498.05,0h-3.428c-7.704,0-13.95,6.245-13.95,13.95v83.848
      v316.405v83.848c0,7.704,6.245,13.95,13.95,13.95h3.428c7.704,0,13.95-6.245,13.95-13.95v-83.848V119.096"/>
      <path style="fill:#36A1CB;" d="M0,13.95v83.848v316.405v83.848C0,505.755,6.245,512,13.95,512h3.428
      c7.704,0,13.95-6.245,13.95-13.95v-83.848V97.798V13.95C31.328,6.245,25.082,0,17.378,0H13.95C6.245,0,0,6.245,0,13.95z"/>
      </g>
      <path style="fill:#EA6428;" d="M230.772,312.165H219.65h-13.336H195.19h-68.539h-11.122h-13.338H91.068
      c-3.489,0-6.318,2.83-6.318,6.32v28.124h152.341v-28.124C237.092,314.996,234.263,312.165,230.772,312.165z"/>
      <path style="fill:#DD4D14;" d="M107.011,318.485c0-3.489,2.828-6.32,6.318-6.32h-11.137H91.068c-3.489,0-6.318,2.83-6.318,6.32
      v28.124h22.261V318.485z"/>
      <path style="fill:#1E834E;" d="M279.002,113.962h11.124h13.336h11.122h68.539h11.124h13.338h11.122c3.492,0,6.32,2.83,6.32,6.32
      v28.124H272.685v-28.124C272.685,116.793,275.513,113.962,279.002,113.962z"/>
      <path style="fill:#147540;" d="M294.945,120.281c0-3.489,2.828-6.32,6.318-6.32h-11.137h-11.124c-3.489,0-6.318,2.83-6.318,6.32
      v28.124h22.261V120.281z"/>
      <g>
      <path style="fill:#605E5A;" d="M178.715,185.618h-17.542c-3.689,0-6.678,2.99-6.678,6.678v19.607h24.22V185.618z"/>
      <path style="fill:#605E5A;" d="M178.715,76.826h-24.22v46.76c0,2.56,1.463,4.894,3.768,6.01c0.925,0.449,1.92,0.668,2.908,0.668
      c1.476,0,2.941-0.489,4.143-1.439l13.401-10.592V76.826z"/>
      <path style="fill:#605E5A;" d="M331.059,383.822h-17.543c-3.69,0-6.678,2.991-6.678,6.678v19.606h24.221V383.822z"/>
      <path style="fill:#605E5A;" d="M331.059,275.029h-24.221v46.76c0,2.56,1.463,4.894,3.768,6.01c2.304,1.116,5.043,0.816,7.052-0.771
      l13.399-10.593l0.002,0.002L331.059,275.029L331.059,275.029z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Stock',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/Stock.vue